module.exports = __webpack_public_path__ + "static/media/France.d1841bc0.svg";